export function authenticatedGetter (state) {
    return state.authenticated
}

export function departmentGetter (state) {
    return state.department
}
